export const AssetValidation = (formData) => {
    const errors = {};

    if (!formData.vc_AssetCode || !formData.vc_AssetCode.trim()) {
        errors.vc_AssetCode = 'This field is required';
    }

    if (!formData.vc_AssetName || !formData.vc_AssetName.trim()) {
        errors.vc_AssetName = 'This field is required';
    }
    
    return errors;
};
